import { NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { getFloatingMenu } from '@/services/apps'
import {
  getWhySezBanner,
  getWhySezInfographicEconomicGrowth,
  getWhySezInfographicNaturalResources,
  getWhySezInfographicPopulation,
  getWhySezInfographicStrategicLocation,
  getWhySezInfrastructureConnectivity,
  getWhySezInfrastructureConnectivityList,
  getWhySezRegulationPolicy,
} from '@/services/why-sez'
import { wrapper } from '@/store'

import WhyInvest from './WhyInvest'

const Page: NextPage = () => {
  return (
    <main className='min-h-screen bg-gray-100'>
      <WhyInvest />
    </main>
  )
}

export const getProps = wrapper.getServerSideProps((store) => async ({ locale }) => {
  const paramsList = {
    params: { skip: 0, limit: 1000 },
    headers: { 'Accept-Language': String(locale) },
  }
  await Promise.all([
    store.dispatch(getWhySezBanner.initiate({ headers: paramsList.headers })),
    store.dispatch(getWhySezInfrastructureConnectivity.initiate({ headers: paramsList.headers })),
    store.dispatch(getWhySezInfrastructureConnectivityList.initiate(paramsList)),
    store.dispatch(getWhySezRegulationPolicy.initiate({ headers: paramsList.headers })),
    store.dispatch(getWhySezInfographicStrategicLocation.initiate({ headers: paramsList.headers })),
    store.dispatch(getWhySezInfographicNaturalResources.initiate({ headers: paramsList.headers })),
    store.dispatch(getWhySezInfographicPopulation.initiate({ headers: paramsList.headers })),
    store.dispatch(getWhySezInfographicEconomicGrowth.initiate({ headers: paramsList.headers })),
    store.dispatch(getFloatingMenu.initiate({ headers: { ...paramsList.headers } })),
  ])
  return {
    props: {
      ...(await serverSideTranslations(String(locale), ['common', 'investment-why-invest'])),
    },
  }
})

export default Page
